module.exports = __webpack_public_path__ + "img/Feature.5033fd75.png";